import { http } from '@/api/http';
import type { OperationResult, Schemas } from '@/api/shared';

export const measurementsApi = {
  /** GET /persons/{guid}/measurements — anthropometric measurements. */
  getMeasurements: (
    guid: string,
    options?: { signal?: AbortSignal },
  ): Promise<OperationResult<'getMeasurements'>> =>
    http.get<OperationResult<'getMeasurements'>>(
      `/persons/${encodeURIComponent(guid)}/measurements`,
      options,
    ),

  /** POST /persons/{guid}/measurements — add a measurement. */
  addMeasurement: (
    guid: string,
    body: Schemas['MeasurementInput'],
    options?: { signal?: AbortSignal },
  ): Promise<Schemas['Measurement']> =>
    http.post<Schemas['Measurement']>(
      `/persons/${encodeURIComponent(guid)}/measurements`,
      body,
      options,
    ),

  /** PUT /persons/{guid}/measurements/{id} — update an existing measurement.
   *  BE responds 200 with empty body; the caller refetches the list to pull
   *  re-computed `valueSD` / `valuePercentile`. */
  updateMeasurement: (
    guid: string,
    id: string,
    body: Schemas['MeasurementInput'],
    options?: { signal?: AbortSignal },
  ): Promise<undefined> =>
    http.put<undefined>(
      `/persons/${encodeURIComponent(guid)}/measurements/${encodeURIComponent(id)}`,
      body,
      options,
    ),

  /** DELETE /persons/{guid}/measurements/{id} — remove a measurement.
   *  The BE doesn't extract `personGuid` / `id` from the URL path despite
   *  the OpenAPI signature saying it does — we have to repeat them in
   *  the request body or the handler errors with "guid is required". */
  deleteMeasurement: (
    guid: string,
    id: string,
    options?: { signal?: AbortSignal },
  ): Promise<undefined> =>
    http.delete<undefined>(
      `/persons/${encodeURIComponent(guid)}/measurements/${encodeURIComponent(id)}`,
      { ...options, body: { personGuid: guid, id } },
    ),
};
